import React, { useState, useEffect } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import BorderBottom from "./atoms/BorderBottom";
import { lockScroll, unlockScroll } from "utils/scrollLock";

const ShippingBanner = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      lockScroll();
    } else {
      unlockScroll();
    }
    return () => { unlockScroll(); };
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === "Escape") setIsOpen(false); };
    if (isOpen) document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen]);

  return (
    <>
      <div className="w-full relative z-[500] bg-[#909090] text-[#edf3f5] min-h-[40px] flex items-start lg:items-center lg:justify-center py-[10px] px-[20px]">
        <p
          className="text-[14px] leading-5 lg:leading-6 cursor-pointer flex items-center relative group hover:underline underline-offset-4"
          onClick={() => setIsOpen(true)}
        >
          Nueva coleccion disponible. Click & Collect en CDMX y Veracruz.
          <FiPlus className="ml-[20px] font-semibold" />
          <BorderBottom />
        </p>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-[9999]"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Slide panel */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "680px",
          maxWidth: "100vw",
          height: "100vh",
          background: "#edf3f5",
          zIndex: 10000,
          transform: isOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "32px 40px 24px" }}>
          <h2 style={{ fontFamily: "'Suisse Intl', system-ui, sans-serif", fontSize: "22px", fontWeight: 400, color: "#1a1a1a", margin: 0 }}>
            Gastos de envío y plazos de entrega
          </h2>
          <button
            onClick={() => setIsOpen(false)}
            style={{ background: "none", border: "none", cursor: "pointer", padding: "8px", color: "#1a1a1a" }}
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: "0 40px 40px", fontFamily: "'Suisse Intl', system-ui, sans-serif" }}>
          {/* Entrega estándar */}
          <div style={{ marginBottom: "32px" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a", marginBottom: "16px" }}>Entrega estándar</h3>
            <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "16px", borderBottom: "1px solid #c8c8c0" }}>
              <span style={{ fontSize: "14px", color: "#1a1a1a" }}>Pedidos regulares</span>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>179 $</span>
            </div>
          </div>

          {/* México */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>México</span>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>3-5 días hábiles</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontSize: "14px", color: "#666" }}>Envíos internacionales</span>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>Aún no disponibles</span>
            </div>
          </div>

          {/* Entrega urgente */}
          <div style={{ marginBottom: "32px" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 400, color: "#1a1a1a", marginBottom: "16px" }}>Entrega urgente</h3>
            <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "16px", borderBottom: "1px solid #c8c8c0" }}>
              <span style={{ fontSize: "14px", color: "#1a1a1a" }}>Todos los pedidos</span>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>Consulte horarios y tarifas</span>
            </div>
            <p style={{ fontSize: "13px", color: "#666", marginTop: "12px", lineHeight: 1.6 }}>
              Haga su pedido antes de las 12 p. m. para recibirlo el siguiente día hábil antes de las 8 p. m. (aplica restricciones)
            </p>
          </div>

          {/* Devoluciones */}
          <div style={{ marginBottom: "32px" }}>
            <h3 style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a", marginBottom: "12px" }}>Devoluciones</h3>
            <p style={{ fontSize: "14px", color: "#1a1a1a", lineHeight: 1.6 }}>
              Las compras realizadas online podrán devolverse sin coste alguno en un plazo de 12 días.
            </p>
          </div>

          {/* Compra en tu ciudad */}
          <div>
            <h3 style={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a", marginBottom: "12px" }}>
              Compra en tu ciudad y recibe en tu domicilio
            </h3>
            <p style={{ fontSize: "14px", color: "#1a1a1a", lineHeight: 1.6 }}>
              En nuestro menú inferior puedes consultar tu distribuidor mas cercano a tu ubicación, consulta nuestros puntos de venta o visita nuestra{" "}
              <a href="/contacto" style={{ color: "inherit", textDecoration: "underline" }}>página de contacto y atención</a>{" "}
              para informarte que distribuidor Physiology esta mas cerca de ti.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingBanner;
